// convert cents to dollars by simple division by 100. We don't want to round this one.
// Used to convert API data to form data
export const transformCentsValueToDollars = (value?: null | number) =>
  (value ?? 0) / 100;

// Use to convert form data in dollars to API data in cents
// This needs to be an integer as this value will be sent to the server as Int!
// Simple 100 multiplication. We disallow cents to have decimal points in the frontend
// But Math.round makes sure that the decimal point is rounded to the nearest integer.
export const transformDollarsValueToCents = (value?: null | number) =>
  Math.round((value ?? 0) * 100);
